import { patientRequestsTyped } from "@/api/patientTyped";
import type { PolicyConsentPayloadDTO } from "@/core/types";

/** We want to explicitly opt-out from the default loading spinner to show skeletons and do optimistic updates */
const params = {
  showLoader: false,
};

export async function appendPatientConsent(data: PolicyConsentPayloadDTO) {
  return patientRequestsTyped.append_patient_consent({ data, params });
}
